gs.component('economyStripeBalance', {
    templateUrl: '/components/economy/stripe.balance.html',
    link: function (DI) {
        var _this = this;
        this.fields = [
            { name: 'date', title: 'Date', required: true, type: 'date', value: Date.today() },
        ];
        this.getButtonText = function () { return 'Show report'; };
        this.loadingStatus = {};
        this.staffnext = DI.$rootScope.staffnext;
        this.customerTab = 'balance';
        this.setCustomerTab = function (v) {
            _this.customerTab = v;
            updatePerCustomer();
        };
        this.submit = function () {
            _this.loadingStatus.loading = true;
            _this.response = null;
            DI.server.post2('/api/stripe/report_totals', {
                'date': _this.fields[0].value
            }).then(function (response) {
                _this.response = response;
                DI.$timeout(function () {
                    _this.config.control.update();
                    updatePerCustomer();
                });
            })["finally"](function () { return _this.loadingStatus.loading = false; });
        };
        var updatePerCustomer = function () {
            _this.configPerCustomer.columns = [{ field: 'host', title: 'Customer' }];
            if (!_this.response)
                return;
            for (var _i = 0, _a = Object.keys(_this.configPerCustomer.getItems()[0]).sort(); _i < _a.length; _i++) {
                var k = _a[_i];
                if (k === 'host')
                    continue;
                _this.configPerCustomer.columns.push({ field: k, title: k, format: 'price' });
            }
            _this.configPerCustomer.control.rebuild();
        };
        var downloading = false;
        var download = function (type) {
            downloading = true;
            DI.fileManager.downloadFileFromServer("/api/stripe/report?type=".concat(type, "&date=").concat(_this.fields[0].value.yyyymmdd()))["finally"](function () {
                _this.loading.report = false;
            })["finally"](function () { return downloading = false; });
        };
        this.config = {
            getItems: function () { return _this.response && _this.response.balance || []; },
            columns: [
                { field: 'date', title: 'Date', format: 'date' },
                { field: 'charges', title: 'Charges', format: 'price' },
                { field: 'refunds', title: 'Refunds', format: 'price' },
                { field: 'fee', title: 'Stripe fee', format: 'price' },
                { field: 'transferred', title: 'Transferred', format: 'price' },
                { field: 'correction', title: 'Correction', format: 'price' },
                { field: 'end_total', title: 'End balance', format: 'price' }
            ],
            searchButtons: [
                { title: 'Download', loading: function () { return downloading; }, onClick: function () { return download('totals'); } }
            ],
            countSuffix: function () { return 'rows'; }
        };
        this.configPerCustomer = {
            getItems: function () {
                if (!_this.response)
                    return [];
                if (_this.customerTab == 'charge')
                    return _this.response.diff;
                else if (_this.customerTab == 'wdiff')
                    return _this.response.wdiff;
                return _this.response.result;
            },
            columns: [],
            searchButtons: [
                { title: 'Download', loading: function () { return downloading; }, showOnEmpty: false, onClick: function () { return download(_this.customerTab); } }
            ],
            countSuffix: function () { return 'rows'; }
        };
    }
});
